export const environment = {
  production: true,
  // Same Firebase project everyrupeespent-mobile uses for FCM - web push shares that pipeline
  // instead of running its own VAPID/web-push stack (see FcmNotificationSender on the backend).
  firebaseConfig: {
    apiKey: 'AIzaSyDXWWy4ttsD_hyKZjFvst_BmxwoLyfYDqY',
    authDomain: 'everyrupeespent-mobile-b4d88.firebaseapp.com',
    projectId: 'everyrupeespent-mobile-b4d88',
    storageBucket: 'everyrupeespent-mobile-b4d88.firebasestorage.app',
    messagingSenderId: '1041977157935',
    appId: '1:1041977157935:web:121e198df14d802bb5d9da',
  },
  // TODO: paste the "Web Push certificate" key pair from Firebase Console > Project Settings >
  // Cloud Messaging > Web Push certificates. Required by getToken() to request a browser token.
  fcmVapidKey: 'BMa1eA-l1xkd6URc-YU62lMkqhmo2WGs7oZ_8YrKA1hbc2NJ6z3OkkZefTghIuOaG6g-wyanYfpGSMPcgz0a23k',
  // TODO: replace with your real Cloudflare Turnstile SITE key (Dashboard > Turnstile > your widget).
  // The matching SECRET key goes in the backend as the TURNSTILE_SECRET_KEY env var.
  turnstileSiteKey: '0x4AAAAAAD39aoTmxM2YtTZS',
  features: {
    // Relaunched 2026-11-03 - RMS validated end-to-end per PENDING_FEATURES.md #1, flipped on
    // together with the backend's app.rms.enabled flag.
    rmsEnabled: true,
    // Off in production until relaunch is decided and the backend's app.rental-agreement.enabled
    // flag is flipped on too - see PENDING_FEATURES.md #3. Flip both together.
    rentalAgreementEnabled: false,
  },
};
